/*
 *
 * SlackVerify actions
 *
 */

import { VERIFY_SLACK_START, VERIFY_SLACK_SUCCESS, VERIFY_SLACK_ERROR } from './constants';

export const verifySlackStart = ({ payload }) => {
  return {
    type: VERIFY_SLACK_START,
    payload,
  };
};

export const verifySlackSuccess = () => {
  return {
    type: VERIFY_SLACK_SUCCESS,
  };
};

export const verifySlackError = error => {
  return {
    type: VERIFY_SLACK_ERROR,
    error,
  };
};
